module.exports = __webpack_public_path__ + "static/img/newPeople.ee39862.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/newPeople.png
// module id = 2h5m
// module chunks = 3